
/**
  * Frontend common
  *
  */
const tgblCredCommonFrontendFunctions = ($) => {

  if (!window.Tangible) return

  const tangibleSelect = window.Tangible.Select
  const ajax = window.Tangible.ajax
  const ajaxConfig = window.Tangible.ajaxConfig
  const LOCALIZED = tgblCredFrontend.localized

  // Global object
  window.tgblCredCommonFrontend = {}

  $(document).ready(function () {
    window.tgblCredCommonFrontend.constructor()
  })

  window.tgblCredCommonFrontend = {

    // initialize the code
    constructor: function () {
      const $_this =this;
      this.test($_this)
    },

    test: function ($_this) {
      //console.log($_this)
    },
  }
}
export {tgblCredCommonFrontendFunctions}
